<script setup lang="ts">
defineOptions({
	name: 'UsersSection',
})

const { t: $t, locale } = useI18n()
const { $tThird } = useNuxtApp()

const firstHtml = computed(() => {
	return $tThird(
		'{users} agree to indemnify and hold {company}, along with its parent company, subsidiaries, affiliates, officers, agents, employees, advertisers, licensors, suppliers, and partners, harmless from and against any claims, liabilities, losses, actual or consequential damages, suits, judgements, litigation costs, and legal fees of any kind or nature that may arise as a result of their:',
		{
			users: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const secondHtml = computed(() => {
	return $tThird('{users} agree that {company} will have control over the defence or settlement of such claims.', {
		users: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
		company: '<span class="font-semibold">Gaveta Decimal</span>',
	})
})

const thirdHtml = computed(() => {
	return $tThird(
		'Furthermore, if {company} reasonably believes that {users} have violated any of the commitments outlined above, it reserves the right, at its sole and absolute discretion, without notice or liability to {users}, to restrict their use of the {platform} and, if permissible by law, to pursue any legal remedies available.',
		{
			users: `<span class="font-semibold ">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const fourthHtml = computed(() => {
	return $tThird(
		'Upon termination or expiration of these {terms}, whether by {users} or {company}, {users} may no longer have access to information they have posted on the {platform} or that is related to them. They acknowledge that {company} is under no obligation to retain any such information within its databases.',
		{
			terms: `<span class="font-semibold">${$t('Terms & Conditions')}</span>`,
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			users_upper: `<span class="font-semibold capitalize">${locale.value === 'fr' ? $t('the User') : $t('Users')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const fivethHtml = computed(() => {
	return $tThird(
		'Similarly, {company} reserves the right, without prior notice, to initiate appropriate legal proceedings, including but not limited to referring matters to law enforcement or regulatory authorities or notifying the affected party of any unlawful or unauthorised use of the {platform}.',
		{
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})

const sixthHtml = computed(() => {
	return $tThird(
		'Furthermore, without limiting the foregoing, {company} has the right to cooperate fully with any law enforcement agencies or court orders requesting or directing us to disclose the identity or other data of any {users} using the {platform}.',
		{
			users: `<span class="font-semibold">${locale.value === 'fr' ? $t('User') : $t('Users')}</span>`,
			platform: `<span class="font-semibold">${$t('Platform')}</span>`,
			company: '<span class="font-semibold">Gaveta Decimal</span>',
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ph:users-three-thin"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">{{ $t('Users') }}</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>

			<ul class="list-disc pl-7 space-y-2.5">
				<li>
					{{ $t('Violation of these') }} <span class="font-semibold">{{ $t('Terms & Conditions') }}</span
					>.
				</li>
				<li>
					{{ $t('Misuse of the') }} <span class="font-semibold">{{ $t('Platform') }}</span
					>.
				</li>
				<li>
					{{ $tThird('Breach of applicable laws, rules, or regulations in connection with their use of the') }}
					<span class="font-semibold">{{ $t('Platform') }}</span
					>.
				</li>
			</ul>
			<p v-html="secondHtml"></p>
			<p v-html="thirdHtml"></p>
			<p v-html="fourthHtml"></p>
			<p v-html="fivethHtml"></p>
			<p v-html="sixthHtml"></p>
		</div>
	</section>
</template>
